import {
	AdjustEventName,
	FeatureTeamEvent,
	TrackingEventType,
	useAnalyticsEventDebouncedSender
} from '@capsicum/common';
import { useAllSearchParams, useRouter } from '@capsicum/common-web';
import { useConversionRates } from '@capsicum/features/wallet/shared';
import { EUR_CURRENCY_ID, useMe } from '@capsicum/socios-core';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export const useAdjustDigest = () => {
	const searchParams = useAllSearchParams();
	const topUpCompletedParam = searchParams.get(AdjustEventName.TOPUP_COMPLETED);
	const currencyId = searchParams.get('CURRENCY_ID');
	const router = useRouter();
	const userId = useMe();
	const path = usePathname();
	const sendAnalyticsEvent = useAnalyticsEventDebouncedSender();
	const { data: conversionRate, isLoading } = useConversionRates([{ from: currencyId || '', to: EUR_CURRENCY_ID }]);

	useEffect(() => {
		if (topUpCompletedParam && !isLoading && conversionRate) {
			sendAnalyticsEvent(TrackingEventType.track, AdjustEventName.TOPUP_COMPLETED, {
				feature_team: FeatureTeamEvent.PFFT,
				revenue: (Number(conversionRate[0]?.rate) || 1) * Number(topUpCompletedParam),
				user_id: userId
			});
			router.replace(path);
		}
	}, [sendAnalyticsEvent, topUpCompletedParam, currencyId, isLoading, conversionRate]);

	return null;
};
